import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	tooltipTriggerAriaLabel: {
		id: 'command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label',
		defaultMessage: 'Command palette tool tip',
		description: 'The aria label for the command palette tooltip',
	},
});
